import React from 'react';
import AdminMasterLayout from '../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import AdminDigiBooks from '../../../subsreens/gcadmin/digibookspage/AdminDigiBooks';


const DigitalBooksManage = () => {
    return(
       <AdminMasterLayout>
        <AdminDigiBooks></AdminDigiBooks>
       </AdminMasterLayout>
    )
}

export default DigitalBooksManage;